import React from 'react';
import { useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import TableOfContentsIcon from '@atlaskit/icon-lab/core/table-of-content';

import { tableOfContentsButtonMessages } from './tableOfContentsButtonMessages.ts';

// Match the loaded button while keeping its implementation behind the dynamic import.
export function TableOfContentsButtonPlaceholder(): React.JSX.Element {
	const { formatMessage } = useIntl();
	const label = formatMessage(tableOfContentsButtonMessages.buttonLabel);
	return (
		<Tooltip content={label} position="left">
			<IconButton
				appearance="subtle"
				icon={TableOfContentsIcon}
				label={label}
				isDisabled
				testId="sidebar-table-of-contents-button"
			/>
		</Tooltip>
	);
}
